import React, { useEffect, useState } from 'react';
import { Button, Image, Space, Table } from 'antd';
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useWebsiteStattistic } from '.';
import { useNavigate } from 'react-router';

const Orders = () => {
  const getLineItemImageUrl = (line) => {
    const image = line?.variant?.image
      || line?.variant?.images?.[0]
      || line?.product?.thumbnail
      || line?.product?.image
      || line?.product?.images?.[0]
      || line?.image
      || line?.images?.[0]
      || null;

    if (!image) return null;
    if (typeof image === 'string') return image;
    return image?.url || null;
  };

  const getOrderImageUrls = (record) => {
    const lineItems = Array.isArray(record?.line_items) ? record.line_items : [];
    return lineItems.map(getLineItemImageUrl).filter(Boolean);
  };

  const getCustomerName = (record) => {
    return (
      record?.customer?.full_name ||
      record?.customer?.name ||
      record?.customer_name ||
      '-'
    );
  };

  const columns = [
    {
      title: 'Đơn hàng',

      render: (_, record) => {
        const imageUrls = getOrderImageUrls(record);
        const visibleImages = imageUrls.slice(0, 3);
        const hiddenCount = imageUrls.length - visibleImages.length;

        return (
          <>
            <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
              {record.id}
            </Button>
            <div>
              {formatDate(record.create_on || record.create_at)}
            </div>
            <div>
              {getCustomerName(record)}
            </div>
            {!!visibleImages.length && (
              <Image.PreviewGroup items={imageUrls}>
                <Space size={4} wrap>
                  {visibleImages.map((url, index) => (
                    <Image
                      key={`${record.id || 'order'}-${index}`}
                      src={url}
                      width={28}
                      height={28}
                      style={{ objectFit: 'cover', borderRadius: 6 }}
                      fallback='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCI+PHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSIjZjVmNWY1Ii8+PC9zdmc+'
                    />
                  ))}
                  {hiddenCount > 0 && (
                    <div
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: 6,
                        background: '#f5f5f5',
                        color: '#595959',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      +{hiddenCount}
                    </div>
                  )}
                </Space>
              </Image.PreviewGroup>
            )}

          </>
        )
      },
    },
    {
      title: 'Thành tiền',
      render: (_, record) => {
        return (
          <>
            {formatCurrency(record.total_amount)}
          </>
        )
      },
    },



  ];

  const navigate = useNavigate();
  const { data } = useWebsiteStattistic();
  const [orders, setorders] = useState([])
  useEffect(() => {
    if (data.orders) {
      setorders(data.orders);
    } else {
      setorders([])
    }
  }, [data.orders])



  return (
    <Table columns={columns} dataSource={orders} rowKey='id' />
  )
};
export default Orders;